import { useDisclosure } from '@mantine/hooks';
import { trackEvent } from '@repo/common/analytics';
import { IconButton } from '@repo/foundations';
import { useCallback } from 'react';
import type { ISecodaEntity } from '../../api';
import { useAuthUser, useWorkspace } from '../../api';
import { trackDashboardShared } from '../../features/BiDashboard/utils/tracking';
import type { SecodaEntity } from '../../lib/models';
import { useCheckEntityUpdatePermission } from '../../utils/authorization/roles';
import { ScrollableModal } from '../ScrollableModal/ScrollableModal';
import { Content } from './Content';
import { Footer } from './Footer';

export function EntityPermissions({
	model,
}: {
	model: SecodaEntity | ISecodaEntity;
}) {
	const { user } = useAuthUser();
	const editorOfEntity = useCheckEntityUpdatePermission({
		entity: model,
	});
	const readOnly = !editorOfEntity;

	const [opened, { close, toggle }] = useDisclosure(false);

	const { workspace } = useWorkspace();

	const trackClick = useCallback(() => {
		trackEvent(
			`${model.entity_type}/share_settings/click`,
			{
				resource_id: model.id,
			},
			user,
			workspace
		);

		if (model.entity_type === 'bi_dashboard') {
			trackDashboardShared(model.id, user, workspace);
		}
	}, [model.entity_type, model.id, user, workspace]);

	const handleClick = () => {
		trackClick();
		toggle();
	};

	return (
		<>
			<IconButton
				iconName="share"
				onClick={handleClick}
				variant="tertiary"
				tooltip="Share and set permissions"
			/>
			<ScrollableModal
				opened={opened}
				title={`Permissions of ${model.title}`}
				onClose={close}
				size="lg"
				footer={<Footer model={model} readOnly={readOnly} />}
				withTopPadding
			>
				<Content model={model} readOnly={readOnly} />
			</ScrollableModal>
		</>
	);
}
